
// Product FAQs open/close
$('.faq-section .question').off().click(function(e) {
  e.preventDefault();
  $(this).siblings('.answer').slideToggle(mobileMenuSlideTime); // jQuery slide before adding active class
  $(this).parent('.faq-item').toggleClass('active');
});
